package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable

@Serializable
data class AccountAbuseFormInfo(
    val reportingReason: String,
    val userReported: String,
    val issueDate: String,
    val userReportedContactInfo: String? = null,
    val otherReason: String? = null,
    val additionalDetails: String? = null
)